"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAppDeepLink = void 0;
const flora_react_1 = require("@grupoboticario/flora-react");
const constants_1 = require("../../constants");
const utils_1 = require("../../../utils");
const SAFARI_BROWSER_REGEX = /^((?!chrome|android).)*safari/i;
const useAppDeepLink = () => {
    const isAnyMobile = (0, flora_react_1.useIsMobile)();
    const isSafari = SAFARI_BROWSER_REGEX.test(navigator.userAgent);
    const { ios, android } = constants_1.CURRENT_BRAND === 'BOT' ? constants_1.APP_BOT_URL : constants_1.APP_EUD_URL;
    const isSafariOnDesktop = isSafari && !isAnyMobile;
    const shouldUseIos = utils_1.isMobile.iOS() || isSafariOnDesktop;
    return shouldUseIos ? ios : android;
};
exports.useAppDeepLink = useAppDeepLink;
